import '@hawkins/components/lib/css/allHawkinsStyles.css';

import ReactDOM from 'react-dom/client';

import App from 'src/App.tsx';
import { RTLProvider } from 'src/components/providers/RTLProvider';
import 'src/i18n/i18n-config';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RTLProvider>
    <App />
  </RTLProvider>
);
